import angular from "angular";

import { OnboardingLogic } from "@salaxy/core";

/**
 * Defines a supported signature method.
 */
export class SignatureMethod {
    /** Title for the signing method. */
    public title?: string;
    /** Name for the signing method. */
    public name: string;
    /** Id for the signing method. */
    public value: string;
    /** Image url for the signing method. */
    public img: string;
    /** Boolean to indicate that the method is popular and should be shown among first methods. */
    public isPopular?: boolean;
}

/**
 * Handles Digital Signature scenarios to Onnistuu.fi-service.
 */
export class SignatureService {

    /**
     * For NG-dependency injection
     * @ignore
     */
    public static $inject = ["$rootScope"];

    private tupasMethods: SignatureMethod[] = null;

    private teliaMethods: SignatureMethod[] = null;

    /**
     * Creates a new instance of SignatureService
     * @param $rootScope - Angular root scope. Used for event routing
     */
    constructor(
        private $rootScope: angular.IRootScopeService,
    ) {
    }

    /**
     * Gets a list of available signature methods. Use img-property to show.
     * @param methodGroup - Method group "telia" for Telia Tunnistus and "tupas" for Visma Sign. Default is "tupas".
     */
    public getMethods(methodGroup: "tupas" | "telia" = "tupas"): SignatureMethod[] {
        methodGroup ??= "tupas";
        switch (methodGroup) {
          case "tupas":
            this.tupasMethods ??= OnboardingLogic.getTupasMethods().map((x) => (
              {
                  id: x.id,
                  title: x.title,
                  name: x.id.substr(6), // for backward compatibility
                  value: x.id,
                  img: x.img,
                  isPopular: x.isPopular,
              }));
            return this.tupasMethods;
          case "telia":
            this.teliaMethods ??= OnboardingLogic.getTeliaMethods().map((x) => (
              {
                  id: x.id,
                  title: x.title,
                  name: x.title,
                  value: x.id,
                  img: x.img,
                  isPopular: x.isPopular,
              }));
            return this.teliaMethods;
          default:
            return [];
        }
    }
}
